import apiClient from '@shared/services/apiClient';
import type { ClinicCategoryType, ClinicCapabilityType } from '@features/clinics/types/clinic';

export interface CreateCategoryTypeRequest {
  name: string;
  displayOrder?: number;
}

export interface UpdateCategoryTypeRequest {
  name: string;
  displayOrder: number;
  isActive: boolean;
}

export interface CreateCapabilityTypeRequest {
  name: string;
  key?: string;
  displayOrder?: number;
}

export interface UpdateCapabilityTypeRequest {
  name: string;
  key: string;
  displayOrder: number;
  isActive: boolean;
}

export const lookupAdminApi = {
  getAllCategoryTypes: async (): Promise<ClinicCategoryType[]> => {
    const res = await apiClient.get('/admin/lookups/category-types');
    return res.data.data;
  },
  createCategoryType: async (request: CreateCategoryTypeRequest): Promise<ClinicCategoryType> => {
    const res = await apiClient.post('/admin/lookups/category-types', request);
    return res.data.data;
  },
  updateCategoryType: async (id: number, request: UpdateCategoryTypeRequest): Promise<ClinicCategoryType> => {
    const res = await apiClient.put(`/admin/lookups/category-types/${id}`, request);
    return res.data.data;
  },
  getAllCapabilityTypes: async (): Promise<ClinicCapabilityType[]> => {
    const res = await apiClient.get('/admin/lookups/capability-types');
    return res.data.data;
  },
  createCapabilityType: async (request: CreateCapabilityTypeRequest): Promise<ClinicCapabilityType> => {
    const res = await apiClient.post('/admin/lookups/capability-types', request);
    return res.data.data;
  },
  updateCapabilityType: async (id: number, request: UpdateCapabilityTypeRequest): Promise<ClinicCapabilityType> => {
    const res = await apiClient.put(`/admin/lookups/capability-types/${id}`, request);
    return res.data.data;
  },
};